import { render, staticRenderFns } from "./AdvancedAttributeGroup.vue?vue&type=template&id=3b7d93fd&scoped=true"
import script from "./AdvancedAttributeGroup.vue?vue&type=script&lang=js"
export * from "./AdvancedAttributeGroup.vue?vue&type=script&lang=js"
import style0 from "./AdvancedAttributeGroup.vue?vue&type=style&index=0&id=3b7d93fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d93fd",
  null
  
)

export default component.exports